import prog1 from '../../assets/images/events_reg_app.webp'
import prog2 from '../../assets/images/ape_nft.webp'
import prog3 from '../../assets/images/medicine_delivery_app.webp'
import prog4 from '../../assets/images/task_pro.webp'
import prog5 from '../../assets/images/dayry_app.webp'
import prog6 from '../../assets/images/phonebook.webp'

export const personalDate = [
  {
    placeName: `LLC "SPM STEEL SYMPHONY"`,
    badge: "Full Time",
    title: "Accountant",
    location: "Ukraine",
    date: "May 2023 - Oct 2023",
  },
];

export const educationDate = [
  {
    placeName: "Teiva Systems",
    title: "ServiceNow Rocket Course 3.0",
    date: "Oct 2023 - Jan 2024",
  },
  {
    placeName: "IT School GoIT",
    title: "Fullstack Developer",
    date: "Nov 2022 - Sep 2023",
  },
  {
    placeName: "National Aerospace University – KhAI",
    title: "Master's degree in Accounting and taxation",
    badge: "Full Time",
    date: "Sep 2015 - Dec 2020",
  },
];

export const contactData = [
  { href: "tel:+380 66 156 7600", text: "+380 66 156 7600" },
  { href: "mailto:inna.dmytrenko.dev@gmail.com", text: "inna.dmytrenko.dev@gmail.com" }
];

export const menuItems = [
  { items: "Home", href: "home" },
  { items: "About", href: "about" },
  { items: "Tech Stack", href: "tech-stack" },
  { items: "Projects", href: "projects" },
  { items: "Contact", href: "contact" }
];

export const projectDate = [
  {
    title: 'Events Registration',
    text: "Events registration project is a full-stack application that handles both user interactions on the front end and data processing on the back end.",
    stack: "HTML , JavaScript, CSS, React, Express.js, MongoDB",
    src: prog1,
    linkPreview: "https://events-registration-app-1.onrender.com/",
    linkCode: "https://github.com/Innuska23/events-registration-app",
    alt: "project Events Registration"
  },
  {
    title: 'Ape-NFT',
    text: "Landing page. The APE NFT application consists of 8 sections: header, hero, about, mind map, faq, arts, contact us and footer",
    stack: "HTML , JavaScript, Tailwind, React",
    src: prog2,
    linkPreview: "https://innuska23.github.io/Ape-NFT/",
    linkCode: "https://github.com/Innuska23/Ape-NFT",
    alt: "project Ape-NFT"
  },
  {
    title: 'Medicine Delivery App',
    text: "The Medicine Delivery app should consist of two pages: the shops page, the shopping cart page.",
    stack: "HTML , JavaScript, SASS, React, Redux.js, Express.js, MongoDB",
    src: prog3,
    linkPreview: "https://innuska23.github.io/medicine-delivery-app/shop/",
    linkCode: "https://github.com/Innuska23/medicine-delivery-app",
    alt: "project Medicine Delivery App"
  },
  {
    title: 'BackEnd TaskPro',
    text: "Creating API endpoints: getting and saving data of boards, columns and cards and configuring the Need Help route.",
    stack: "MongoDB, Cloudinary, Swagger API, Node.js",
    src: prog4,
    linkPreview: "https://taskpro-backend-zulp.onrender.com/api-docs/",
    linkCode: "https://github.com/klav28/GoIT-FS-Backend",
    alt: "project BackEnd TaskPro"
  },
  {
    title: 'Dayry App',
    text: "The Dayry App is a modern web application designed to help users track their daily tasks and activities efficiently.",
    stack: "HTML , JavaScript, SASS, React, Redux.js",
    src: prog5,
    linkPreview: "https://innuska23.github.io/test-task-blynk/",
    linkCode: "https://github.com/Innuska23/test-task-blynk",
    alt: "project Dayry App"
  },
  {
    title: 'Phonebook',
    text: "This application allows users to efficiently save and create contacts, providing a user-friendly interface for managing personal or professional contact information.",
    stack: "React, Redux, REST API, MERN, Node.js",
    src: prog6,
    linkPreview: "https://innuska23.github.io/goit-react-hw-08-phonebook",
    linkCode: "https://github.com/Innuska23/goit-react-hw-08-phonebook",
    alt: "project Phonebook"
  }

]


export const skillData = [
  {
    iconId: "htmlSvg",
    height: "120",
    width: "120",
    viewBox: "0 0 120 120"
  },
  {
    iconId: "cssSvg",
    height: "119",
    width: "120",
    viewBox: "0 0 120 119"
  },
  {
    iconId: "jsSvg",
    height: "120",
    width: "120",
    viewBox: "0 0 120 120"
  },
  {
    iconId: "reactSvg",
    height: "101",
    width: "113",
    viewBox: "0 0 113 101"
  },
  {
    iconId: "reduxSvg",
    height: "100",
    width: "105",
    viewBox: "0 0 105 100"
  },
  {
    iconId: "bootstrapSvg",
    height: "87",
    width: "88",
    viewBox: "0 0 88 87"
  },
  {
    iconId: "tailwindSvg",
    height: "131",
    width: "131",
    viewBox: "0 0 131 131"
  },
  {
    iconId: "sassSvg",
    height: "87",
    width: "117",
    viewBox: "0 0 117 87"
  },
  {
    iconId: "gitSvg",
    height: "105",
    width: "105",
    viewBox: "0 0 105 105"
  },
  {
    iconId: "greensockSvg",
    height: "120",
    width: "120",
    viewBox: "0 0 120 120"
  },
  {
    iconId: "vscodeSvg",
    height: "112",
    width: "112",
    viewBox: "0 0 112 112"
  },
  {
    iconId: "github",
    height: "88",
    width: "88",
    viewBox: "0 0 88 88"
  }
];

export const socialIconsData = [
  {
    iconId: 'githubSvg',
    width: '30',
    height: '30',
    viewBox: '0 0 30 30',
    href: 'https://github.com/Innuska23',
    ariaLabel: 'Github',
  },
  {
    iconId: 'linkedinSvg',
    width: '30',
    height: '30',
    viewBox: '0 0 30 30',
    href: 'https://www.linkedin.com/in/innadmytrenko/',
    ariaLabel: 'LinkedIn',
  },
];
